const ContingencyModalContent = contingency => (
  <>
    <h3>{contingency.name}</h3>
    <p>{contingency.description}</p>
  </>
);

export default ContingencyModalContent;
